import { types, ISearch, SearchActionsType } from '../types/search'

export const initialState: ISearch = {
  isLoading: false,
  items: [],
  totalCount: 0,
  skip: 0,
}

export const search = (
  state = initialState,
  action: SearchActionsType
): ISearch => {
  switch (action.type) {
    case types.SEARCH_PACKS__STARTED:
      return { ...state, isLoading: true }
    case types.SEARCH_PACKS__SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: [...state.items, ...action.items],
        totalCount: action.totalCount,
      }
    case types.SEARCH_PACKS__FAILURE:
      return { ...state, isLoading: false }
    case types.UPDATE_SKIP_QUERY:
      return { ...state, skip: action.skip }
    case types.RESET_SEARCH:
      return initialState
    default:
      return state
  }
}
